import React from 'react';
import tw from 'twin.macro';

export const Marker = ({ label = undefined, ...restProps }) => {
  if (!label) return;
  return (
    <span
      css={[
        tw`bg-brand px-2 py-[1px] text-[9px] rounded-[0.5rem] font-black text-dark text-center`,
      ]}
      {...restProps}
    >
      {label.toUpperCase()}
    </span>
  );
};
